import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Condpg } from '../interfaces/condpg';
import { CondPgP } from '../interfaces/cong-pg-p';
import { Observable } from 'rxjs';
import { PageResult } from '../interfaces/page-result';
import { JwtAuthService } from './auth/jwt-auth.service';

@Injectable({
  providedIn: 'root'
})
export class CondpgService {

  readonly path = '/condpg';

  constructor(private http: HttpClient, public jwtAuthService: JwtAuthService) {}

  create(): Observable<Condpg> {
    return this.http.post<Condpg>(`${this.jwtAuthService.apiUrl + this.path}`, null);
  }

  saveOrUpdate(condPg: Condpg): Observable<Condpg> {
    return this.http.put<Condpg>(`${this.jwtAuthService.apiUrl + this.path}`, condPg);
  }

  saveOrUpdateParcela(condPgP: CondPgP): Observable<CondPgP[]> {
    return this.http.put<any>(`${this.jwtAuthService.apiUrl + this.path}/parcela`, condPgP);
  }

  getCondPg(id: number ): Observable<Condpg> {
    return this.http.get<Condpg>(`${this.jwtAuthService.apiUrl + this.path}/${id}`);
  }

  getCondPgPage(page?: number, size?: number,
    order?: string, direction?: string): Observable<PageResult<Condpg>> {
    return this.http.get<PageResult<Condpg>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=`
     + `${size}&order=${order}&direction=${direction}`);
  }

  getCondPgPageSearch(page?: number, size?: number,  search?: string,
    order?: string, direction?: string): Observable<PageResult<Condpg>> {
    return this.http.get<PageResult<Condpg>>(`${this.jwtAuthService.apiUrl + this.path}/page/get/?page=${page}&size=` +
    `${size}&search=${search}&order=${order}&direction=${direction}`);
  }
}
